import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AuthLayout } from "@/components/app/AuthLayout";
import { Field } from "@/components/app/kit";
import { api, formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setDone(data.message);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <AuthLayout title="Mot de passe oublié" subtitle="Indiquez votre adresse e-mail pour générer un lien de réinitialisation.">
      {done ? (
        <div className="rounded-xl border border-emerald-200 bg-emerald-50 p-5 text-sm text-emerald-800 flex gap-3" data-testid="forgot-password-success">
          <MailCheck className="h-5 w-5 shrink-0" />
          <div>
            <p>{done}</p>
            <p className="mt-2 text-emerald-700/80">Aucun service d'e-mail n'est encore configuré : le lien est consultable par l'administration de la plateforme (journal d'envoi).</p>
          </div>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <Field label="Adresse e-mail" required>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input" />
          </Field>
          {error && <p className="text-sm text-red-600" data-testid="forgot-error">{error}</p>}
          <Button type="submit" className="w-full h-11" disabled={busy} data-testid="forgot-submit-button">
            {busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />}Générer le lien
          </Button>
        </form>
      )}
      <Link to="/connexion" className="block mt-6 text-sm text-sky-700 hover:underline" data-testid="back-to-login-link">Retour à la connexion</Link>
    </AuthLayout>
  );
}
